import {Component, EventEmitter, Input, OnInit} from '@angular/core';

import {DataHeader} from './classes/data-header';
import {DataRow} from './classes/data-row';
import {DataHeaderGroup} from './classes/data-header-group';

import {IDataTable} from './interfaces/data-table.interface';

@Component({
    selector: 'reporting-table',
    templateUrl: './reporting-table.component.html',
    styleUrls: ['./reporting-table.component.scss'],
})
export class ReportingTableComponent implements OnInit {
    public hasGroupedColumn: boolean;
    public toggleableRowColSpan: number;
    public tableColumnsLength: number;

    @Input() public noWrapText: boolean;
    @Input() public secondaryTable: boolean;
    @Input() public config: IDataTable;
    @Input() public noPaddingWrap: boolean;
    @Input() public toggleForm: EventEmitter<boolean>;

    constructor() {
        if (!this.toggleForm) {
            this.toggleForm = new EventEmitter();
        }

        this.hasGroupedColumn = false;
        this.tableColumnsLength = 0;
        this.toggleableRowColSpan = 2;
    }

    ngOnInit() {
        if (!this.config) {
            this.config = {
                rows: [],
                columns: [],
                hiddenColumnIds: [],
                sortByRowIndex: false,
                hasToggleableOrCheckableRows: false,
            };
        }

        this.config.columns.forEach((column: DataHeader | DataHeaderGroup) => {
            if (column instanceof DataHeaderGroup) {
                this.hasGroupedColumn = true;

                column.childColumns.forEach((childColumn: DataHeader) => this.tableColumnsLength++);
            } else {
                this.tableColumnsLength++;
            }
        });

        if (this.config.sortByRowIndex) {
            this.config.rows.sort((current: DataRow, next: DataRow) => {
                return current.rowIndex - next.rowIndex;
            });
        }
    }

    onRowChecked(checkedRow: DataRow): void {
        if (checkedRow.isMainRow) {
            this.config.rows.filter((row: DataRow) => (checkedRow.rowIndex === row.subRowOf))
                .map((row: DataRow) => row.checked = checkedRow.checked);
        }
    }
}
